import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@pushpay/theming';
import { ExtendedChMSTheme } from './theme/extended-theme';
import { AuthProvider } from './contexts/AuthContext';
import { PeopleDataProvider } from './contexts/PeopleDataContext';
import { GroupsDataProvider } from './contexts/GroupsDataContext';
import Dashboard from './components/Dashboard';
import Groups from './components/Groups';
import People from './components/People';
import Needs from './components/Needs';
import { GroupDetail } from './components/GroupDetail';
import { PersonDetail } from './components/PersonDetail';

function App() {
  return (
    <ThemeProvider theme={ExtendedChMSTheme}>
      <AuthProvider>
        <PeopleDataProvider>
          <GroupsDataProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/dash" element={<Dashboard />} />
                <Route path="/groups" element={<Groups />} />
                <Route path="/groups/detail/:id" element={<GroupDetail />} />
                <Route path="/people" element={<People />} />
                <Route path="/people/detail/:id" element={<PersonDetail />} />
                <Route path="/community" element={<People />} />
                <Route path="/community/detail/:id" element={<PersonDetail />} />
                <Route path="/needs" element={<Needs />} />
                <Route path="/" element={<Navigate to="/dash" replace />} />
              </Routes>
            </BrowserRouter>
          </GroupsDataProvider>
        </PeopleDataProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
